// features
import Feedback from "./Features/Feedback";

/*
    Parses the features object.
*/
const ParseFeatures = (features = {}) => {
	const featuresMap = {};

	// parse features
	featuresMap.feedback = Feedback(features.feedback);

	return featuresMap;
};

export default ParseFeatures;
